export const salesforceConfig = {
  orgId: process.env.REACT_APP_SALESFORCE_ORG_ID,
  productFieldId: process.env.REACT_APP_SALESFORCE_PRODUCT_FIELD_ID,
  actionUrl: process.env.REACT_APP_SALESFORCE_WEBTOCASE_URL,
  product: "EVA"
} as const;

export interface SupportTicketValues {
  subject: string;
  description: string;
  name: string;
  email: string;
  phone: string;
  company: string;
}

export function buildWebToCaseParams(
  values: SupportTicketValues,
  retUrl: string
): URLSearchParams {
  const params = new URLSearchParams();
  if (salesforceConfig.orgId) params.set("orgid", salesforceConfig.orgId);
  params.set("retURL", retUrl);
  params.set("subject", values.subject);
  params.set("description", values.description);
  params.set("name", values.name);
  params.set("email", values.email);
  params.set("phone", values.phone);
  params.set("company", values.company);
  if (salesforceConfig.productFieldId) {
    params.set(salesforceConfig.productFieldId, salesforceConfig.product);
  }
  return params;
}
